import { render } from "./MarketingConsentModal.vue?vue&type=template&id=887bd33a&scoped=true"
import script from "./MarketingConsentModal.vue?vue&type=script&lang=js"
export * from "./MarketingConsentModal.vue?vue&type=script&lang=js"

import "./MarketingConsentModal.vue?vue&type=style&index=0&id=887bd33a&scoped=true&lang=css"

import exportComponent from "../../../momsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-887bd33a"]])

export default __exports__